var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialog",
      attrs: {
        title: _vm.title,
        visible: _vm.isVisible,
        "show-close": _vm.isClosable,
        width: "30%",
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isVisible = $event
        },
      },
    },
    [
      _c("span", { domProps: { innerHTML: _vm._s(_vm.content) } }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.isButtonActive("yes")
            ? _c("el-button", { on: { click: _vm.start } }, [_vm._v("Yes")])
            : _vm._e(),
          _vm._v(" "),
          _vm.isButtonActive("no")
            ? _c("el-button", { on: { click: _vm.close } }, [_vm._v("No")])
            : _vm._e(),
          _vm._v(" "),
          _vm.isButtonActive("close")
            ? _c("el-button", { on: { click: _vm.close } }, [_vm._v("Close")])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }